import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const Icon = ({
  size = 24,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-seed-icon": "true",
    "data-seed-icon-version": "0.0.10",
    width: size,
    height: size,
    ref,
    ...props,
    children: /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.0689 2.60286C16.526 3.08276 16.5075 3.84233 16.0276 4.29941L7.94 12.0024L16.0276 19.7043C16.5075 20.1614 16.526 20.921 16.069 21.4009C15.6119 21.8808 14.8524 21.8994 14.3724 21.4423L5.37244 12.8715C5.13462 12.645 5.00001 12.3309 5 12.0025C4.99999 11.6741 5.13458 11.36 5.37238 11.1335L14.3724 2.56153C14.8523 2.10445 15.6119 2.12296 16.0689 2.60286Z",
        fill: "currentColor"
      }
    ) })
  }
);
const IconChevronLeftFill = forwardRef(Icon);
export default IconChevronLeftFill;
